<template>
  <zb-radio-group
    :action="plansAction"
    :model-value="_value"
    v-bind="$attrs"
  >
    <slot
      v-for="slot in Object.keys($slots)"
      :key="slot"
      :name="slot"
      v-bind="$slots[slot].scope || {}"
    />
  </zb-radio-group>
</template>
<script>
import ZbRadioGroup from '@/components/zoom-ui-plus/radio/radio-group.vue';

export default {
  name: 'CycleRadioGroup',
  props: {
    plans: Array,
    action: Function,
    value: [String, Number, Boolean, Array],
    modelValue: [String, Number, Boolean, Array],
  },
  computed: {
    _value() {
      return this.modelValue == undefined ? this.value : this.modelValue;
    }
  },
  methods: {
    plansAction(oldVal, val) {
      const oldPlan = this.plans.find(item => item.billing_cycle === oldVal);
      const newPlan = this.plans.find(item => item.billing_cycle === val);
      return this.action(oldPlan, newPlan);
    },
  },
  components: {
    ZbRadioGroup,
  },
}
</script>
